// extracted by mini-css-extract-plugin
module.exports = {"toBeCenter":"VideoPlayer_toBeCenter__3NS-d","videoPlayer":"VideoPlayer_videoPlayer__3Eod4"};